import { render, staticRenderFns } from "./user-advertising-history.vue?vue&type=template&id=224d4ed7&scoped=true"
import script from "./user-advertising-history.vue?vue&type=script&lang=js"
export * from "./user-advertising-history.vue?vue&type=script&lang=js"
import style0 from "./user-advertising-history.vue?vue&type=style&index=0&id=224d4ed7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d4ed7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224d4ed7')) {
      api.createRecord('224d4ed7', component.options)
    } else {
      api.reload('224d4ed7', component.options)
    }
    module.hot.accept("./user-advertising-history.vue?vue&type=template&id=224d4ed7&scoped=true", function () {
      api.rerender('224d4ed7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/user-advertising-history.vue"
export default component.exports